import { render, staticRenderFns } from "./VueNotification.vue?vue&type=template&id=5b4265b0&"
import script from "./VueNotification.js?vue&type=script&lang=js&"
export * from "./VueNotification.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports